import React from "react";
import { useTranslation } from "../../../../i18n/LanguageContext";
import "../../css/Common.css";
import "./css/TextMessageAnalysis.css";
import "./css/SmsAnalysisSimple.css";
import "./css/SmsAnalysisSimpleDesktop.css";

// Import sub-components
import SmsAnalysisResultsSimple from "./components/SmsAnalysisResultsSimple";
import SmsAnalysisDetailsSimple from "./components/SmsAnalysisDetailsSimple";
import SmsCheckStart from "./components/SmsCheckStart";
import DisclosuresModal from "../common/DisclosuresModal";
import HelpGuideButton from "../../HelpGuideButton";

const SmsAnalysisSimpleDesktop = ({
  selectedAnalysis,
  analyses,
  handleAnalysisSelected,
  handleReanalyzeWithContext,
  refreshAnalyses,
  userUuid,
  setError,
  scrollToAnalysisResults,
  onAnalysisDeleted,
  showOriginalMessageInline,
  setShowOriginalMessageInline,
  showMobileOriginalMessage,
  setShowMobileOriginalMessage,
  reportIdMap = {},
  onNavigateToManual,
  userPhone,
  awaitState,
  onStartAwaiting,
  onCancelAwaiting,
  hasLoaded = true,
}) => {
  const isMobile = () => window.innerWidth <= 768;
  const { t } = useTranslation();
  const hasHistory = analyses.length > 0;

  return (
    <>
      <div className="common-header">
        <h1 className="main-title">{t("sms.page.title")}</h1>
        <div className="subtitle-with-help">
          <p className="common-subtitle">{t("sms.page.subtitle")}</p>
          {hasHistory && <HelpGuideButton guideId={2} />}
        </div>
      </div>

      {hasLoaded && (
        <SmsCheckStart
          variant={hasHistory ? "compact" : "full"}
          userPhone={userPhone}
          awaitState={awaitState}
          onStartAwaiting={onStartAwaiting}
          onCancelAwaiting={onCancelAwaiting}
          onPasteInstead={onNavigateToManual}
        />
      )}

      {hasHistory && (
        /* Two-Panel Layout to match Email Analysis */
        <div className="analysis-layout two-panel">
          {/* Left Panel - SMS Analysis List (45%) */}
          <div className="left-panel">
            {/* <div className="panel-content sms-analysis-simple-desktop-panel-content"> */}
            <SmsAnalysisResultsSimple
              rawAnalyses={analyses}
              selectedAnalysis={selectedAnalysis}
              onAnalysisClick={handleAnalysisSelected}
              onRefresh={refreshAnalyses}
              userUuid={userUuid}
              onError={setError}
              onAnalysisDeleted={onAnalysisDeleted}
              isMobile={isMobile()}
              showMobileOriginalMessage={showMobileOriginalMessage}
              onToggleMobileOriginalMessage={setShowMobileOriginalMessage}
              onNavigateToManual={onNavigateToManual}
            />
            {/* </div> */}
          </div>

          {/* Right Panel - Analysis Details (54.5%) */}
          <div className="right-panel">
            {/* <div className="panel-content sms-analysis-simple-desktop-panel-content"> */}
            {/* <div className="case-details sms-analysis-simple-desktop-case-details"> */}
            <SmsAnalysisDetailsSimple
              selectedAnalysis={selectedAnalysis}
              onScrollToAnalysisResults={scrollToAnalysisResults}
              onReanalyzeWithContext={handleReanalyzeWithContext}
              showOriginalMessageInline={showOriginalMessageInline}
              onToggleOriginalMessageInline={setShowOriginalMessageInline}
              reportId={
                selectedAnalysis?.id
                  ? reportIdMap[selectedAnalysis.id]
                  : undefined
              }
            />
            {/* </div> */}
            {/* </div> */}
          </div>
        </div>
      )}

      <DisclosuresModal disclaimerText={t("sms.disclaimer")} />
    </>
  );
};

export default SmsAnalysisSimpleDesktop;
